import { IMasterclass } from '@shared';
import { DUPLICATE_COURSE_IDS_WARNING } from '../back-office-conf';

export interface IDuplicateCourseId {
  courseId: string;
  moduleLabel: string;
  locations: string[];
}

export const findDuplicateCourseIds = (masterclasses: IMasterclass[]): IDuplicateCourseId[] => {
  const duplicates: IDuplicateCourseId[] = [];
  masterclasses?.forEach((masterclass) =>
    masterclass.modules?.forEach((module) => {
      const locationsByCourseId = new Map<string, string[]>();
      module.chapters?.forEach((chapter) =>
        chapter.courses?.forEach((course) => {
          const locations = locationsByCourseId.get(course.id) ?? [];
          locations.push(`${chapter.name} > ${course.name}`);
          locationsByCourseId.set(course.id, locations);
        })
      );
      locationsByCourseId.forEach((locations, courseId) => {
        if (locations.length > 1) {
          duplicates.push({ courseId, moduleLabel: `${masterclass.name} > ${module.name}`, locations });
        }
      });
    })
  );
  return duplicates;
};

export const formatDuplicateCourseIds = (duplicates: IDuplicateCourseId[]): string => {
  return duplicates.map((duplicate) => `${duplicate.moduleLabel} :\n    ${duplicate.locations.join('\n    ')}`).join('\n\n');
};

export const confirmDuplicateCourseIds = (masterclasses: IMasterclass[]): boolean => {
  const duplicates = findDuplicateCourseIds(masterclasses);
  if (!duplicates.length) {
    return true;
  }
  return window.confirm(`${DUPLICATE_COURSE_IDS_WARNING}\n\n${formatDuplicateCourseIds(duplicates)}`);
};
